<template>
  <div class="row">
    <input-text
      class="col-12 col-md-2"
      label="Nº parcela"
      readonly
      v-model="form.desembolso.parcela"
      ref="parcela"
      required
    />
    <input-select
      class="col-12 col-md-5"
      label="Tomador de serviços"
      :options="options.tomador"
      v-model="form.desembolso.tomador"
      ref="tomador"
      required
    />
    <input-select
      class="col-12 col-md-5"
      label="Prestador de serviços"
      :options="options.prestador"
      v-model="form.desembolso.prestador"
      ref="prestador"
      required
    />

    <input-text
      class="col-12 col-md-3"
      label="Nº da nota"
      v-model="form.desembolso.numero"
      ref="numero"
      required
    />
    <input-date-time
      class="col-12 col-md-3"
      label="Data do faturamento"
      v-model="form.desembolso.dataFaturamento"
      ref="data"
      required
    />
    <input-money
      class="col-12 col-md-3"
      label="Valor bruto"
      v-model="form.desembolso.valorBruto"
      ref="valor"
      required
    />
    <input-money
      class="col-12 col-md-3"
      label="Impostos"
      v-model="form.desembolso.impostos"
      ref="imposto"
    />

    <input-select
      :class="`col-12 col-md-${verificarSubtipo(form.desembolso.subtipo) ? 6 : 12}`"
      label="Vincular subtipo"
      :options="options.subtipo"
      v-model="form.desembolso.subtipo"
      ref="subtipo"
      required
    />
    <input-select
      :class="`col-12 col-md-6`"
      v-if="verificarSubtipo(form.desembolso.subtipo)"
      label="Selecione o subtipo"
      :options="options.entregaveis.filter((el) => el.subtipo == form.desembolso.subtipo)"
      v-model="form.desembolso.entregavelId"
      ref="entregavel"
      required
    />

    <input-text
      class="col-12"
      label="Descrição"
      v-model="form.desembolso.descricao"
      ref="descricao"
      required
    />

    <div class="col-12 mb-2">
      <upload v-if="!form.desembolso.nomeArquivoAWS"
        id="anexo_cronograma_financeiro"
        tituloArquivo="Arrastar Arquivo"
        selecioneArquivo="Selecionar Arquivo"
        type=".*"

        :arquivo-download="form.desembolso.conteudoBase64"
        :arquivo-download-nome="form.desembolso.nomeArquivoAWSUP"

        @upload="
          (file, nomeArquivo) => {
            form.desembolso.conteudoBase64 = file;
            form.desembolso.nomeArquivoAWSUP = nomeArquivo;
          }
        "
      />

      <template v-if="form.desembolso.nomeArquivoAWS">
        <div>
            Arquivo
            <div class="lista-arquivos d-flex">
                <b-button variant="danger" @click="() =>{form.desembolso.nomeArquivoAWS = null;}" class="m-2" size="sm">
                    <b-icon icon="trash" class="mr-2" />
                    Remover arquivo
                </b-button>
                <b-button variant="info" @click="() =>{this.$emit('downloadArquivo', form.desembolso.id);}" class="m-2" size="sm">
                    <i class="fas fa-cloud-download"></i>
                </b-button>
                <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                    {{form.desembolso.nomeArquivoAWS}}
                </div>
            </div>
        </div>
    </template>
    </div>
  </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputDateTime from "@/components/inputs/InputDateTime";
import InputMoney from "@/components/inputs/InputMoney";
import Upload from "@/components/upload/Upload";

import ProjetoService from "@/common/services/projeto/projeto.service";

import helpers from "@/common/utils/helpers";
import { FormMixin } from "@/common/mixins/FormMixin";

export default {
  name: "ModalCronogramaFinanceiroPrevisto",
  mixins: [FormMixin],
  components: {
    InputText,
    InputSelect,
    InputDateTime,
    InputMoney,
    Upload,
  },
  props: {
    projetoId: {
      type: String,
      required: true,
    },
    projetoIdBase: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    options: {
      subtipo: helpers.getSubTiposCronogramaFinanceiro(),
      tomador: [],
      prestador: [],
      entregaveis: [],
    },
  }),
  methods: {
    formatarTextoEntregavel(entregavel) {
      if (entregavel.tipo == "RelatorioAtividades" && entregavel.vinculadoARelatorioEtapa)
        return entregavel.relatorioEtapa.titulo;

      let tipoEntregavel = helpers.getTipoEntregavel(entregavel.tipo.trim());
      let texto = tipoEntregavel.text;
      if (tipoEntregavel.value != tipoEntregavel.subtipo)
        texto = `${helpers.getEnum(tipoEntregavel.subtipo).text}`;
      return `${texto} ${entregavel.sequencial}`;
    },
    verificarSubtipo: function (subtipo) {
      switch (subtipo) {
        case null:
          return false;
        case "SemVinculo":
          return false;
        case "AssinaturaDoContrato":
          return false;
        default:
          return true;
      }
    },

    buscarEntregaveis: function () {
      ProjetoService.listarGenerico("entregavel", this.projetoIdBase).then((response) => {
        this.options.entregaveis = response.data.data.map((entregavel) => {
          return {
            text: this.formatarTextoEntregavel(entregavel),
            value: entregavel.id,
            subtipo: entregavel.vinculadoARelatorioEtapa
              ? "RelatorioDeEtapas"
              : entregavel.tipo,
          };
        });
      });
    },

    buscarTomador: function () {
      ProjetoService.listarEmpresasInvestidoras(this.projetoIdBase).then((response) => {
        this.options.tomador = response.data.data.map((el) => {
          return {
            value: el.projetoInvestidoraId || el.projetoCooperadaInvestidoraId,
            text: el.razaoSocial,
            el: el,
          };
        });
      });
    },

    buscarPrestador: function () {
      ProjetoService.listarEmpresasAssociadas(this.projetoIdBase).then((response) => {
        this.options.prestador = response.data.data.map((el) => {
          return {
            value:
              el.projetoEmpresaExecutoraCriadoraReceptoraId ||
              el.projetoEmpresaExecutoraReceptoraId,
            text: el.razaoSocial,
            el: el,
          };
        });
      });
    },
  },
  mounted() {
    this.buscarEntregaveis();
    this.buscarTomador();
    this.buscarPrestador();
  },
  watch: {
    form: {
      handler: function () {
        this.$emit(
          "notas",
          parseFloat(helpers.removerValor(`${this.form.desembolso.valorBruto}`))
        );
      },
      deep: true,
    },
  },
};
</script>
<style>
    .lista-arquivos{
        border: 1px solid #e5e5e5;
        background: #f9f9f9;
    }
    .lista-arquivos__no_top{
        border-top: none;
    }
    .lista-arquivos__left{
        border-left: 1px solid #e5e5e5;
    }
</style>
